import {Component,OnInit,ElementRef,Input} from "@angular/core";
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "../../services/data.service";
import { InPurchasesService } from "../../services/inventory/in-purchases.service";

export interface ConfirmModel21 {
  title: string;
}


@Component({
  selector: 'app-grn-search',
  templateUrl: './grn-search.component.html',
  styleUrls: ['./grn-search.component.css']
})
export class GrnSearchComponent extends DialogComponent<ConfirmModel21, boolean> implements ConfirmModel21, OnInit {
  title: string;
  loading: boolean = false;
  result: any = { item: [], result: false };;
  rtnData: any;
  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  f: any = {
    Code: "",
    Name: ""
  };
  private el: ElementRef;
  @Input() onReturn: string;
  fullData: any=[];

  constructor(dialogService: DialogService,private ips: InPurchasesService,private ds: DataService) {
    super(dialogService);
    this.listGrn();
  }
  
  ngOnInit() {
   
  }

  listGrn() { 
    var data = {
      LocationId:this.ds.Settings.LocationId
    }
    this.loading = false;
    this.ips.Get_GrnForSearch(data).subscribe(res => {
      if (res.Success) {
        this.fullData = res.data;
        this.loading = true;
      }
      else {
        this.fullData = [];
        this.loading = true;
      }
    })
  }

  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    document.getElementById("focus").focus();
  }
  NextBut() {
    if (!this.NexbutEnable()) {
      this.sliceEnd = Number(this.sliceEnd) + 15
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.sliceEnd = Number(this.sliceEnd) - 15
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {
    return this.fullData.legth > this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 16
  }
  ItesmSearch(e, type) {
    if (e.keyCode == 13 && e.which == 13) {
      switch (type) {
        case "Code":
          this.f.Code = e.target.value;
          break;
        case "Name":
          this.f.Name = e.target.value;
          break;
      }
      this.selectedRow = 0;
    } else if (e.keyCode == 40 && e.which == 40) {
      document.getElementById("focus").focus();
      this.selectedRow = 0;
    }
  }
  scroll(event: KeyboardEvent) {
    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      this.selecedItem();
    }
    else return;
  }
  selecedItem() {
    var abc = document.getElementsByClassName("selectedItesmsaerch786")[0].getElementsByClassName("bkd")[0].innerHTML;
    var bcd = this.fullData.find(x => x.Code == abc);
    this.confirm(bcd);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/grn-search/grn-search.component.ts